export const STATUS_MESSAGES = {
  success: 'Ваша заявка успешна принята. В ближайшее время с Вами свяжется наш менеджер.',
  error: 'При отправке данных произошла ошибка. Пожалуйста, повторите попытку позже.',
};
